export default __webpack_public_path__ + "static/media/classic_band.7004e099.webp";